// import

import { articleCategoryOpts, projectCategoryOpts } from './terms';
import { createBoolean, createDate, createImage, createList, createMark, createMediaLibrary, createObject, createLineMark, createString, createText, createParaMark, required, createSelect } from './utils';

// base

export const title = createString({
  name: 'title',
  label: 'Title',
  pattern: [
    '^.{0,60}$', 
    'Must be 60 characters or less',
  ],
});

export const niceTitle = createParaMark({
  name: 'niceTitle',
  label: 'Displayed Title',
  required: false,
});

export const subtitle = createLineMark({
  name: 'subtitle',
  label: 'Subtitle',
  required: false,
});

export const slug = createString({
  name: 'slug',
  label: 'Slug',
  required: false,
  pattern: [
    '^[a-z0-9]+(?:-[a-z0-9]+)*$', 
    'Must be lowercase with dashes',
  ],
});

export const pathSlug = createString({
  name: 'slug',
  label: 'Slug',
  required: false,
  pattern: [
    '^[a-z0-9]+(?:-[a-z0-9]+)*(?:\\/[a-z0-9]+(?:-[a-z0-9]+)*)*$', 
    'Must be lowercase with dashes and slashes',
  ],
});

export const redirect = createString({
  name: 'redirect',
  label: 'Redirect to...',
  required: false,
  pattern: [
    '^(?:https?:\\/\\/|\\/).*$', 
    'Must be an absolute URL',
  ],
});

export const redirected = createList({
  name: 'redirected',
  label: 'Redirected from...',
  label_singular: 'Redirect',
  required: false,
  field: required(pathSlug),
});

export const bannerImage = createImage({
  name: 'bannerImage',
  label: 'Banner Image',
  media_library: createMediaLibrary({
    config: {
      folder: {path: 'msc.com/banners'},
    }
  })
});

// seo

export const excerpt = createText({
  name: 'excerpt',
  label: 'Excerpt',
  pattern: [
    '^.{50,160}$', 
    'Must be 50-160 characters',
  ],
});

export const canonical = createString({
  name: 'canonical',
  label: 'Canonical URL',
  pattern: [
    '^(?:https?:\\/\\/|\\/).*$', 
    'Must be an absolute URL',
  ],
  required: false,
});

// publish dates

export const publishDate = createDate({
  name: 'publishDate',
  label: 'Publish Date',
  required: false,
});

export const updateDate = createDate({
  name: 'updateDate',
  label: 'Update Date',
  required: false,
});

// projects

export const projectCategory = createSelect({
  name: 'category',
  label: 'Category',
  options: projectCategoryOpts,
});

export const launchDate = createDate({
  name: 'launchDate', 
  label: 'Launch Date', 
  required: false,
});

export const retireDate = createDate({
  name: 'retireDate', 
  label: 'Retire Date', 
  required: false,
});

export const absoluteUrl = createString({
  name: 'link',
  label: 'Link',
  required: false,
  pattern: [
    '^(?:https?:\\/\\/|\\/).*$', 
    'Must be an absolute URL',
  ],
});

export const links = createList({
  name: 'links',
  label: 'Links',
  collapsed: true,

  fields: [
    createString({
      name: 'text',
      label: 'Text',
    }),
    absoluteUrl,
  ],
});

export const blurb = createLineMark({
  name: 'blurb',
  label: 'Blurb',
});

// books

export const coverImage = createImage({
  name: 'coverImage',
  label: 'Cover Image',
  media_library: createMediaLibrary({
    config: {
      folder: {path: 'msc.com/books'},
    }
  })
});

export const series = createString({
  name: 'series',
  label: 'Series',
  required: false,
});

export const buyLinks = createObject({
  name: 'buyLinks',
  label: 'Buy Links',
  fields: [
    {...absoluteUrl, name: 'amazon', label: 'Amazon'},
  ],
});

// articles

export const articleCategory = createSelect({
  name: 'category',
  label: 'Category',
  options: articleCategoryOpts,
});

export const tags = createList({
  name: 'tags',
  label: 'Tags',
});

export const featured = createBoolean({
  name: 'featured',
  label: 'Featured',
  required: false,
});

// tips

export const short = createBoolean({
  name: 'short',
  label: 'Short',
  required: false,
});

// body

export const body = createMark({
  name: 'body',
  label: 'Body',
  buttons: [
    'bold',
    'italic',
    'code',
    'link',
    'heading-two',
    'heading-three',
    'heading-four',
    'heading-five',
    'heading-six',
    'quote',
    'bulleted-list',
    'numbered-list',
  ],
});
